/**
 * Design tokens for the Inventory Manager app, taken 1:1 from the Product SOT
 * Figma (colour + type styles) so screens match the mobile flow exactly.
 */
export const brand = {
  green: "#469428", // buttons/primary
  newBadge: "#9907AD", // surface/announcement — "New" badge
  link: "#3A09FF", // content/link — "Sign out", selectors
  text1: "#111111", // content/content-1 — primary text
  text2: "#7E7E7E", // content/content-2 — secondary text
  border: "#ECECEC", // borders/gray
  surfaceNeutral: "#FAFAFA", // surface/neutral — pills/bars
  surfaceGray: "#ECECEC", // surface/gray — avatar bg
  // Status-chip tones: one soft-fill construction (bg + border + label) per
  // semantic, so every status reads as the same chip in a different colour.
  status: {
    accent: { bg: "#F5E9F7", border: "#E4C9EA", label: "#9907AD" }, // new
    positive: { bg: "#EAF5E6", border: "#C9E5BF", label: "#2E6B18" }, // ready / done
    progress: { bg: "#FFF6E5", border: "#F2D6A2", label: "#8A5A00" }, // processing
    info: { bg: "#EEEAFE", border: "#D5CEFF", label: "#4436C7" }, // sent / waiting
    danger: { bg: "#FDECEC", border: "#F4C7C7", label: "#B42318" }, // retry / rejected
    muted: { bg: "#FAFAFA", border: "#ECECEC", label: "#5F5F5F" }, // cancelled
  },
} as const;

/** Avenir families loaded via /assets/fonts/fonts.css (see index.html). */
export const font = {
  light: "avenir_lt_light, Helvetica, sans-serif",
  roman: "avenir_lt_roman, Helvetica, sans-serif",
  book: "avenir_lt_book, Helvetica, sans-serif",
  medium: "avenir_lt_medium, Helvetica, sans-serif",
  heavy: "avenir_lt_heavy, Helvetica, sans-serif",
} as const;
